import { Component, Input, OnInit } from '@angular/core';
import { ElapsedPipe } from '../elapsed.pipe';
import { Achievement, Flags } from '../models';

@Component({
  selector: 'app-record-timer',
  templateUrl: './record-timer.component.html',
  styleUrls: ['./record-timer.component.scss'],
  providers: [ElapsedPipe]
})
export class RecordTimerComponent implements OnInit {

  @Input() achievement: Achievement;
  athlete;
  country;
  name;

  constructor() { }

  ngOnInit() {
    this.athlete = JSON.parse(localStorage.getItem('athlete'));
    this.country = Flags[this.athlete.country];
    this.name = this.athlete.firstname.substring(0,1) +'.'+this.athlete.lastname;
 }

}
